import { CommonModule } from '@angular/common';
import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, FormsModule, NgForm, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';

import { Reopen } from '../../classes/reopen';
import { Student } from '../../classes/student';
import { AppService } from '../../services/app.service';
import { SettingsService } from '../../services/settings.service';
import { SnackBarService } from '@polk_county_public_schools/ngx-pcps-dialogs/snackbar';
import { UserInfo, UserService } from '../../services/user.service';
import { SchoolYearPipe } from '../../pipes/schoolyear/schoolyear.pipe';
import { ErrorService } from '../../services/error.service';

@Component({
    selector: 'app-reopen-application',
    templateUrl: './reopen-application.component.html',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatInputModule,
        MatCardModule,
        FormsModule,
        MatDividerModule,
        SchoolYearPipe,
        MatButtonModule
    ]
})
export class ReopenApplicationComponent implements OnInit {
    protected readonly destroyRef = inject(DestroyRef);
    protected readonly appSvc = inject(AppService);
    protected readonly router = inject(Router);
    protected readonly settingSvc = inject(SettingsService);
    protected readonly snackBarSvc = inject(SnackBarService);
    protected readonly userSvc = inject(UserService);
    protected readonly errorSvc = inject(ErrorService);
    user: UserInfo;
    schoolYear: string;
    studentID: string;
    student: Student;
    reopenForm: FormGroup;
    deadline: string;
    pastDeadline: boolean;
    delay: boolean = true;

    ngOnInit() {
        this.user = this.userSvc.User;
        this.getSettings();
        this.createForm();
    }

    getSettings() {
        this.settingSvc.SettingsSubject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(settings => {
            if (settings == null) return;
            this.schoolYear = settings.find(f => f.Label === 'School year (scholarship admin)').Value;
            this.deadline = settings.find(f => f.Label === 'Scholarship app end date').Value;
            this.pastDeadline = new Date() > new Date(this.deadline);
        });
    }

    createForm() {
        this.reopenForm = new FormGroup({
            AuthorizedBy: new FormControl('', Validators.required),
            Reason: new FormControl('', Validators.required)
        });
    }

    search(form: NgForm) {
        if (form.invalid) {
            return;
        }

        this.appSvc.SearchStudent(form.value.studentID).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            next: res => {
                this.student = res;
                this.delay = false;
            }, error: error => {
                this.errorSvc.HandleServiceError(error);
                this.delay = false;
            }
        });
    }

    submit(form: FormGroup) {
        if (form.invalid) {
            return;
        }

        let dto: Reopen = {
            StudentID: this.student.StudentID,
            Type: this.pastDeadline ? 'Emergency Access' : 'Reopen',
            AuthorizedBy: form.value.AuthorizedBy,
            Reason: form.value.Reason
        };

        this.appSvc.ReopenApplication(dto).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            next: res => {
                this.snackBarSvc.success('Submit Successful', 5000);
                this.router.navigate(['/admin-home']);
            }, error: error => {
                this.errorSvc.HandleServiceError(error);
            }
        });
    }
}
